import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { RootState } from './types';

import { notification } from '@cnamts/vue-dot/src/modules/notification';

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
	strict: true,
	state: {},
	modules: {
		notification
	}
};

export const store = new Vuex.Store<RootState>(storeOptions);
